<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :modeVersions="modeVersions"
    titleKey="last_version.name"
  >
  </WsRead>
</template>

<script>
import model from "@/models/checklist_conclusion_daily_template";
import submodel from "@/models/checklist_question_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    modeVersions: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: [
                "last_version.locales.name",
                "last_version.locales.remark",
              ],
              hideLabelFields: [],
            },
          ],
        },
        {
          type: "expandList",
          label: submodel.label,
          modelName: submodel.modelName,
          modeParent: true,
          modeParentVersions: true,
          fields: submodel.fields,
          titleKey: "title",
          fieldsRead: submodel.fieldsRead,
          searchMode: false,
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "frequency",
                "area",
                "system_class",
                "system_subclasses",
                "industry_categories",
              ],
            },
          ],
        },
        {
          type: "activeSwitch",
          title: "啟用",
          remark: "隱藏的內容將不會顯示於前端",
          field: "is_active",
        },
      ],
    },
  }),
};
</script>